export default __webpack_public_path__ + "static/subset-Aeroport-Bold-1c30797a673cc391d89b2dd004e2d95c.woff2";